<template>
	<a href="/">
		<img
			class="block m-auto" 
			:src="logoSrc" 
			:alt="logoAlt" 
			:style="{
				'width': width,
				'max-width': maxWidth
			}"
		/>
	</a>
</template>

<script>
export default {
	name: 'UiLogo',
	props: {
		mode: {
			type: String,
			default: 'primary'
		},
		width: {
			type: String,
			default: '100%'
		},
		maxWidth: {
			type: String,
			default: '100%'
		}
	},
	computed: {
		logoSrc() {
			return this.mode === 'secondary'
				? 'https://cdn.atpoc.com/cdn/assets/production/breakingmed/logos/brmed-kaplan-logo-png/BreakingMED-Kaplan-Color-DarkBG.png'
				: 'https://cdn.atpoc.com/cdn/assets/production/breakingmed/logos/brmed-kaplan-logo-png/BreakingMED-Kaplan-Color-WhiteBG.png'
		},
		logoAlt() {
			return 'BreakingMED'
		}
	}
}
</script>